import React, { useEffect, useState } from "react";
import "./HealthInformationManager.css";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import Select from "react-select";
import {
  queueOptions,
  usersOptions,
} from "./redux/HealthInsuranceManagerSlicer";
import { useDispatch, useSelector } from "react-redux";
// import { HimTableData, HimTablefilterFieldsOptions, queueOrthopaedicsData, queueRespiratoryData, apiResponse } from "../Utils";
import {
  episodeAssignmentCodeWorkflow,
  updateAssignmentFilters,
} from "./redux/HealthInsuranceManagerSlicer";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { fetchOutstandingReportData } from "../Reports/redux/ReportsSlice";
const WorkflowAudiAssignModal = ({
  isAllEpisodesSelected,
  selectedRecord,
  setWorkflowHimsAssginModal,
  selectedHimEpisodes,
  uncheckedIds
}) => {
  const {
    users: { usersData, isUserPageTrue, usersLoading, usersPageNumber },
    queue: { queueData, queuePageNumber, queueLoading, isQueuePageTrue },
  } = useSelector((state) => state.healthInsuranceManager);
  const { episodeAssignmentPayload } = useSelector(
    (state) => state.healthInsuranceManager
  );
  const {
    episodeAssignmentLoading,
    episodeAssignmentResponse,
    episodeAssignmentError,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerAssignment
  );
  const filtersPayload = useSelector(
    (state) =>
      state.healthInsuranceManager.healthInsuranceManagerEpisodesPayload
  );
  const dispatch = useDispatch();
  const [isEpisodeFlagged, setIsEpisodeFlagged] = useState(false);
  const queueSelectOptions =
    queueData?.map((item) => ({
      label: item.queue_name,
      value: item.queue_id,
    })) || [];

  const userSelectOption = usersData?.map((item) => ({
    label: item.user_name,
    value: item.user_id,
  }));

  const handleHimSelectChange = (fieldName, value) => {
    dispatch(
      updateAssignmentFilters({
        [fieldName]: value,
      })
    );
  };

  const getValueFromApi = (key, itemId) => {
    if (key === "queue") {
      const queues = queueData || [];
      const matchedQueue = queues.find((q) => q?.queue_name === itemId);
      return matchedQueue?.queue_id ? matchedQueue?.queue_id : itemId;
    } else if (key === "coders") {
      const users = usersData || [];
      const matchedUser = users.find((u) => u?.user_name === itemId);
       return matchedUser?.user_id >= 0 ? matchedUser?.user_id : 0;
    }
  };

  const confirmAssgineHanlder = () => {
    const uniqueUncheckedIds = [...new Set(uncheckedIds)];
    const payload = {
      // hcp_lines: selectedHimEpisodes.length > 0 ? selectedHimEpisodes : [selectedRecord?.hcp_line_id],
      hcp_lines: isAllEpisodesSelected ? [] : selectedHimEpisodes?.length > 0 ? selectedHimEpisodes?.map(item => item?.hcp_line_id) : [selectedRecord?.hcp_line_id],
    // hcp_lines: selectedHimEpisodes.length > 0 ? selectedHimEpisodes?.map((item) => item?.hcp_line_id) : [selectedRecord?.hcp_line_id],
      assigned_user_id: episodeAssignmentPayload?.assigned_user_id !== undefined && episodeAssignmentPayload?.assigned_user_id !== null ? episodeAssignmentPayload.assigned_user_id : getValueFromApi('coders', selectedRecord.assigned_user),
      // select_all: uniqueUncheckedIds.length > 0 ? false : isAllEpisodesSelected,
      select_all: uncheckedIds.length > 0 ? true : isAllEpisodesSelected,
      unchecked_ids : !episodeAssignmentPayload?.select_all && uniqueUncheckedIds.length > 0? uniqueUncheckedIds : [],
      assigned_queue_id: episodeAssignmentPayload.assigned_queue_id ? episodeAssignmentPayload.assigned_queue_id : getValueFromApi('queue', selectedRecord.queue),
      is_flagged: episodeAssignmentPayload?.is_flagged ?? false,
      filters: {
        separation_date_from: filtersPayload.separation_date_from
          ? filtersPayload.separation_date_from
          : null,
        separation_date_to: filtersPayload.separation_date_to
          ? filtersPayload.separation_date_to
          : null,
        speciality: filtersPayload.speciality.length
          ? filtersPayload.speciality
          : [],
        queue: filtersPayload.queue.length ? filtersPayload.queue : [],
        queue_priority: filtersPayload.queue_priority.length
          ? filtersPayload.queue_priority
          : [],
        status: filtersPayload.status.length > 0 ? filtersPayload.status : [],
        coders: filtersPayload.coders.length > 0 ? filtersPayload.coders : [],
      },
    };
    dispatch(episodeAssignmentCodeWorkflow(payload));
    setTimeout(()=>{
      dispatch(fetchOutstandingReportData({
      pageNumber:1,
      selectedFilters: {},
    }));
    },300);
    setWorkflowHimsAssginModal(false);
  };

  return (
    <div>
      <div className="workflow-him-assign-modal-overlay-fade">
        <div className="workflow-him-assign-modal-container">
          <div className="workflow-him-assign-header">
            <p className="workflow-him-assign-header-text">
              Assign episode to:
            </p>
            <span onClick={() => setWorkflowHimsAssginModal(false)}>
              <img src={closeIcon} />
            </span>
          </div>
          <div className="workflow-him-assign-body">
            <div className="workflow-him-assign-container">
              <label className="workflow-him-assign-label">Queue</label>
              {/* <Select
                name="queue"
                // onMenuOpen={handleQuesOption}
                options={queueSelectOptions}
                value={
                  selectedRecord.speciality
                    ? {
                        value: selectedRecord.speciality,
                        label: selectedRecord.speciality,
                      }
                    : null
                }
                // styles={customStyles}
                // maxMenuHeight={250}
                className="workflow-him-assign-select"
                placeholder="queues"
                // onChange={(selectedOption) => {
                //   const selectedValues = selectedOption.map(
                //     (option) => option.value
                //   );
                //   handleHimSelectChange("speciality", selectedValues);
                // }}
              /> */}
              <Select
                name="queue"
                options={queueSelectOptions}
                value={
                  queueSelectOptions.find(
                    (opt) =>
                      opt.value === episodeAssignmentPayload.assigned_queue_id
                  ) ||
                  (selectedRecord.queue
                    ? {
                        value: selectedRecord.queue,
                        label: selectedRecord.queue,
                      }
                    : null)
                }
                className="workflow-him-assign-select"
                placeholder="queue"
                onChange={(selectedOption) => {
                  handleHimSelectChange(
                    "assigned_queue_id",
                    selectedOption.value
                  );
                }}
              />
            </div>
            <p className="workflow-him-assign-divider">OR</p>
            <div className="workflow-him-assign-container">
              <label className="workflow-him-assign-label">
                Individual Coder
              </label>
              <Select
                name="coder"
                options={userSelectOption}
                value={userSelectOption.find(
                  (opt) =>
                    opt.value === episodeAssignmentPayload.assigned_user_id
                ) ||
                (selectedRecord.assigned_user
                  ? 
                  {
                    value: getValueFromApi("coders", selectedRecord.assigned_user),
                    label: selectedRecord.assigned_user,
                  }
                  : null)
              }
                className="workflow-him-assign-select"
                placeholder="coder"
                onChange={(selectedOption) => {
                  handleHimSelectChange(
                    "assigned_user_id",
                    selectedOption.value
                  );
                }}
              />
              {/* <Select
                // isMulti
                name="individual_coder"
                onMenuOpen={handleUserOption}
                options={userSelectOption}
                // value={getSelectedOptions('speciality')}
                // styles={customStyles}
                // maxMenuHeight={250}
                className="workflow-him-assign-select"
                placeholder="Individual Coder"
                // onChange={(selectedOption) => {
                //   const selectedValues = selectedOption.map(
                //     (option) => option.value
                //   );
                //   handleHimSelectChange("speciality", selectedValues);
                // }}
              /> */}
            </div>
            <div>
              <p className="workflow-him-assign-label-section">
                <input
                  type="checkbox"
                  checked={episodeAssignmentPayload.is_flagged}
                  onChange={(e) => {
                    dispatch(
                      updateAssignmentFilters({
                        is_flagged : e.target.checked,
                      })
                    );
                  }}
                />
                <label>Flag this episode as urgent</label>
              </p>
            </div>
            <div className="workflow-him-assign-footer">
              <div className="workflow-him-assign-footer-btn-section">
                <button
                  className="workflow-him-assign-cancel-btn"
                  onClick={() => setWorkflowHimsAssginModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="workflow-him-assign-confirm-btn"
                  onClick={confirmAssgineHanlder}
                >
                  {episodeAssignmentLoading ? <Spinner /> : "Confirm assignment"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowAudiAssignModal;
